module.exports = "/packs/images/svg/accessibility/poolside_hoist~926378d7fa16dfe234e03d9de630e510.svg";